import React, { useState } from "react";
import { useWatchContractEvent } from "wagmi";
import { VAULT_ABI, VAULT_ADDRESS } from "../config/contracts";
import { TIER_LABEL, shortAddr, fmtBnb, LOGO_URL, GOLD_ZONGZI_URL } from "./Brand";

function timeAgo(ms) {
  const d = Date.now() - ms;
  if (d < 60_000) return "刚刚";
  if (d < 3600_000) return `${Math.floor(d / 60_000)} 分钟前`;
  if (d < 86_400_000) return `${Math.floor(d / 3600_000)} 小时前`;
  return `${Math.floor(d / 86_400_000)} 天前`;
}

function WinnerRow({ w }) {
  const t = TIER_LABEL[w.tier];
  const colorClass = w.tier === 1 ? "text-amber-300" : w.tier === 2 ? "text-amber-200" : "text-teal-300";
  const icon = w.tier === 1
    ? <img src={LOGO_URL} alt="" className="w-6 h-6 rounded-full" />
    : w.tier === 2
      ? <img src={GOLD_ZONGZI_URL} alt="" className="w-6 h-6 object-contain" />
      : <span className="text-xl">{t.emoji}</span>;
  return (
    <span className="inline-flex items-center gap-3 text-sm md:text-base">
      {icon}
      <span className="text-emerald-100/85">恭喜</span>
      <span className="addr text-amber-200">{shortAddr(w.addr)}</span>
      <span className="text-emerald-100/85">斩获</span>
      <span className={`font-display font-bold ${colorClass}`}>{t.name}</span>
      <span className="text-amber-300 font-num">{fmtBnb(w.amount, 3)} BNB</span>
      <span className="text-emerald-200/40 text-xs">· {timeAgo(w.at)}</span>
      <span className="text-emerald-200/30">·</span>
    </span>
  );
}

export default function WinnersMarquee() {
  const [winners, setWinners] = useState([]);

  // 监听链上中奖事件
  useWatchContractEvent({
    address: VAULT_ADDRESS || undefined,
    abi: VAULT_ABI,
    eventName: "DrawCompleted",
    enabled: !!VAULT_ADDRESS,
    onLogs(logs) {
      const newWinners = logs
        .filter((l) => Number(l.args?.tier) > 0)
        .map((l) => ({
          addr: l.args.user,
          tier: Number(l.args.tier),
          amount: l.args.amount,
          at: Date.now(),
        }));
      if (newWinners.length) {
        setWinners((prev) => [...newWinners, ...prev].slice(0, 30));
      }
    },
  });

  const hasWinners = winners.length > 0;
  const doubled = hasWinners ? [...winners, ...winners] : [];

  return (
    <section id="winners" className="relative z-10 mt-10 px-6 md:px-10">
      <div className="flex items-center gap-3 mb-3">
        <span className="text-2xl">📣</span>
        <h3 className="font-display text-xl md:text-2xl">实时中奖榜</h3>
        <span className="pulse-dot ml-1" />
      </div>
      <div className="glass-dark gold-border py-4 marquee" data-testid="winners-marquee">
        {hasWinners ? (
          <div className="marquee-track">
            {doubled.map((w, i) => (
              <WinnerRow key={`${w.addr}-${i}`} w={w} />
            ))}
          </div>
        ) : (
          <div className="text-center text-emerald-100/60 text-sm py-2 px-4">
            ⏳ 活动未开始，首位锦鲤虚位以待 · 敬请期待
          </div>
        )}
      </div>
    </section>
  );
}
